// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","listInfrastructure":"infrastructure_listInfrastructure__hG0rJ","cheked":"infrastructure_cheked__hRDgs"};